export default "__VITE_ASSET__VslKEOkh__"